export default "__VITE_PUBLIC_ASSET__d86a31f4__"